import React from "react";
import StaffCard from "@/modules/staff/components/StaffCard";
import { EntityCardGrid } from "../../../shared/components/patterns";

export default function StaffGrid({
  staff,
  onSelect,
  onEdit,
  onArchive,
  canManageStaff = false,
  emptyMessage = "Nessun membro del personale disponibile.",
}) {
  if (!staff.length) {
    return <EntityCardGrid emptyState={emptyMessage} />;
  }

  return (
    <div className="staff-list-sections">
      {[
        ["Attivi", staff.filter((member) => member.status !== "inactive")],
        ["Disattivati", staff.filter((member) => member.status === "inactive")],
      ].map(([title, members]) =>
        members.length ? (
          <section key={title} className="staff-list-section">
            <h2>
              {title} <span>{members.length}</span>
            </h2>
            <EntityCardGrid>
              {members.map((member) => (
                <StaffCard
                  key={member.id}
                  member={member}
                  onClick={onSelect}
                  onEdit={onEdit}
                  onArchive={onArchive}
                  canManageStaff={canManageStaff}
                />
              ))}
            </EntityCardGrid>
          </section>
        ) : null,
      )}
    </div>
  );
}
